/**
 * NativeScript helpers
 */

// eslint-disable-next-line functional/no-let
declare let NSObject: any;
// eslint-disable-next-line functional/no-let
let NSString: any;
// eslint-disable-next-line functional/no-let
let android: any;
// eslint-disable-next-line functional/no-let
let java: any;

/**
 * Determine if running on native iOS mobile app
 */
export function isIOS() {
  return typeof NSObject !== 'undefined' && typeof NSString !== 'undefined';
}

/**
 * Determine if running on native Android mobile app
 */
export function isAndroid() {
  return typeof android !== 'undefined' && typeof java !== 'undefined';
}

/**
 * Determine if running on native iOS or Android mobile app
 */
export function isNativeScript() {
  return isIOS() || isAndroid();
}
